import { useModals } from '@/router';

export default function Managment() {
  const modals = useModals();

  return (
    <section style={{ margin: 24 }}>
      <h1>App</h1>
      <button onClick={() => modals.open('/app/modal')} type="button">
        Global modal at current route
      </button>
    </section>
  );
}
